<div class="wrapper-margin">
    <!-- Grid Result Header Wrapper  -->
    <div class="result-header">
        <!-- Grid Result Header Wrapper -->
        @if (resultGridHeader.currentCategory) {
        <div class="header-titles-wrapper">
            <h1 class="header-title" tabindex="-1">
                <!-- Grid Header  => Title parentCollection -->
                <span class="header-title-parent">
                    {{ resultGridHeader.currentCategory.masterCategoryName }}&nbsp;
                </span>
                <!-- Grid Result Header - Current Collection Title -->
                <span class="header-title-current" role="text" data-testid="header-title-current">
                    <span class="header-result-title">
                        {{ resultGridHeader.currentCategory.name }}
                    </span>
                    @if (resultGridHeader.facetDisplayName) { - {{ resultGridHeader.facetDisplayName }}
                    }
                </span>
            </h1>
            <p class="total-items-collection" aria-hidden="true" data-testid="number-current-result">
                ({{ resultGridHeader.collectionSize }})
            </p>
            @if (resultGridHeader.collectionSize) {
            <p class="sr-only">
                <span>{{ resultGridHeader.collectionSize }} </span>
                @if (resultGridHeader.collectionSize < 2) {
                <span i18n="@@hermes.accessibility.product">item</span>
                } @else {
                <span i18n="@@hermes.accessibility.products">items</span>
                }
            </p>
            }
            <!-- For screen reader only. Informs the user that the products list has been updated -->
            <p
                class="sr-only"
                aria-live="polite"
                i18n-aria-live
                aria-atomic="true"
                [attr.aria-hidden]="resultGridHeader.hideTotalUpdatedItems">
                <span i18n="@@hermes.accessibility.update">Update</span>
                @if (resultGridHeader.collectionSize) {
                <span>, {{ resultGridHeader.collectionSize }} </span>
                @if (resultGridHeader.collectionSize < 2) {
                <span i18n="@@hermes.accessibility.product">item</span>
                } @else {
                <span i18n="@@hermes.accessibility.products">items</span>
                } }
            </p>
        </div>
        }
        <!-- END Grid Result Header -->
    </div>
    <!-- END Grid Header Wrapper -->
</div>
